import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BrochureViewer.css';

const BrochureViewer = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    // Navigate back if possible, otherwise go to home
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="brochure-page">
      <header className="brochure-header">
        <h1>📖 Company Brochure</h1>
        <button className="back-button" onClick={handleBack}>← Go Back</button>
      </header>

      <div className="pdf-frame">
        <iframe
          title="Company Brochure"
          src="/brochure.pdf#toolbar=0"
          allow="fullscreen"
        />
      </div>
    </div>
  );
};

export default BrochureViewer;
